import React from 'react'

import {
  BathSvg,
  BedSvg,
  CarSvg,
  ChevronSvg,
  PowderSvg,
  StarSvg,
  StudySvg,
} from '@svg/react'

function HeadSkeleton() {
  return (
    <div className="sticky top-0 z-10 flex w-full items-center justify-between bg-[#EEEEEE] py-3">
      <div className="h-3 w-24 rounded bg-zinc-400/20"></div>
      <ChevronSvg className="h-6 w-6" rotate="right" />
    </div>
  )
}

function CardSkeleton() {
  return (
    <div className="mb-2.5 cursor-pointer rounded-md bg-white">
      <div className="px-6 py-5">
        <div className="mb-2 flex justify-between gap-1">
          <div className="flex min-w-0 items-center">
            <div className="flex-1 truncate">
              <div className="h-3 w-12 rounded bg-zinc-400/20"></div>
            </div>
            <span className="ml-4 h-2 w-2 rounded-full"></span>
            <div className="h-3 w-24 rounded bg-zinc-400/20"></div>
          </div>
          <div title="Shortlist unit">
            <StarSvg className="h-4 w-4 stroke-zinc-400 text-zinc-400" />
          </div>
        </div>

        <div className="flex gap-3 text-zinc-500">
          <div className="inline-flex items-center gap-1 text-sm" title="Bed">
            <BedSvg className="h-4 w-4" />1
          </div>
          <div className="inline-flex items-center gap-1 text-sm" title="Study">
            <StudySvg className="h-4 w-4" />1
          </div>
          <div className="inline-flex items-center gap-1 text-sm" title="Bath">
            <BathSvg className="h-4 w-4" />1
          </div>
          <div
            className="inline-flex items-center gap-1 text-sm"
            title="Powder"
          >
            <PowderSvg className="h-4 w-4" />1
          </div>
          <div className="inline-flex items-center gap-1 text-sm" title="Car">
            <CarSvg className="h-4 w-4" />1
          </div>
        </div>
      </div>
    </div>
  )
}

function SidePanelSkeleton() {
  return (
    <div className="custom-scrollbar h-unit-sidepanel-container overflow-hidden px-4">
      <div>
        <HeadSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
      <div>
        <HeadSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
      <div>
        <HeadSkeleton />
        <CardSkeleton />
        <CardSkeleton />
        <CardSkeleton />
      </div>
    </div>
  )
}

export default SidePanelSkeleton
